import {
  ChangeDetectionStrategy,
  Component,
  Input,
  Inject,
  Renderer2,
  OnChanges, SimpleChanges, OnDestroy
} from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { APP_CATEGORY_ROUTE } from '~shared/constants';
import { ApplicationEventService } from '~shared/modules/application-event/services/application-event.service';
import { ApplicationNavigationEventType } from '~shared/modules/application-event/constants';
import { NavigationApplicationEvent } from '~shared/modules/application-event/models';
import { Category } from '~app/modules/generic/models';
import { ProductsListUrlService } from '~app/modules/generic/services/products-list-url.service';
import { BreadcrumbsSchema } from '~shared/constants/breadcrumbs-schema.constants';
import { BreadcrumbsSchemaGeneratorUtil as schemaGenerator} from '~shared/utils/breadcrumbs-schema-generator.util';

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BreadcrumbsComponent implements OnChanges, OnDestroy{
  @Input() categories: Category[];
  @Input() isOnlyHomeActive = false;
  @Input() isDesktop = false;

  //TODO we have to use category route in the future, keep it here
  categoryRoute = `/${APP_CATEGORY_ROUTE}`;

  constructor(private applicationEventService: ApplicationEventService,
              private productsListUrlService: ProductsListUrlService,
              private renderer: Renderer2,
              @Inject(DOCUMENT) private document: Document) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if( JSON.stringify(changes.categories?.previousValue) !==  JSON.stringify(changes.categories?.currentValue)) {
      this.setProductSchemaScript(changes.categories?.currentValue);
    }
  }

  ngOnDestroy(): void {
    document.getElementById(BreadcrumbsSchema.scriptId)?.remove();
  }

  navigateTo(category: Category) {
    this.productsListUrlService.subCategoryId = category.id;
    this.applicationEventService.publish(
      new NavigationApplicationEvent(
        ApplicationNavigationEventType.Breadcrumb,
        category.name
      )
    );
  }

  private setProductSchemaScript(categories: Category[]) {
    const schemeText = JSON.stringify(schemaGenerator.generateSchema(categories));
    const schemeScript = document.getElementById(BreadcrumbsSchema.scriptId);
    const script = this.renderer.createElement('script');
    script.type = BreadcrumbsSchema.scriptType;
    script.id = BreadcrumbsSchema.scriptId;
    if(schemeScript) {
      schemeScript.innerText = schemeText;
    } else {
      script.text = schemeText;
      this.renderer.appendChild(this.document.body, script);
    }
  }
}
